import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Sends request for the entity of each {@link ecModels.Target} as soon as it is
 * set
 */
export const triggerGetEntity = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    // FIXME: this should trigger when an ID is changed, and it should not
    // trigger when an unrelated ID/target changes
    plugin.storage.selectors.idLookupKeys.asObservable.pipe(
      rxjs.exhaustMap(targets =>
        rxjs.from(
          feature.actions.getEntity
            .from('triggerGetEntity (effect)')
            .bulkCreate(...targets.map(target => ({ target }))),
        ),
      ),
    ),
)
